// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x7rY","clinicsSelect":"styles_clinicsSelect__YcXZH"};